import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import {
  PARENT_FORM_CATEGORY_SLUG,
  SIL_HOME_PROFILE_TABS,
  //   PARENT_FORM_CATEGORY_SLUG,
  //   USER_ROLE,
} from "Constants/constant";
import {
  classNames,
  parseBooleanVal,
  SilHomeselectedTabState,
} from "Utils/utils";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import SilHomeProfileTabItem from "./SilHomeProfileTabItem";
import { roleAccess, canViewAuditLogActivity } from "helpers/RolesPermission";
import { getSpRosteringSetting } from "store/selector/sp.selector";
import PropertyProfile from "../sections/PropertyProfile";
import SubmittedFormView from "components/ServiceProvider/SubmittedFormsView";
import SilRooms from "../sections/SilRooms";
import CaseNotesTab from "components/ServiceProvider/Participant/CaseNotes";
import SilAccommodationSettings from "../sections/Settings";
import Documents from "pages/HRM/Pages/Worker/Documents/index";
import { ActivityTab } from "components/common/AuditLog";
import { trackTabSwitch } from "Utils/trackTabSwitch";
import silApi from "store/services/sil.services";
import {
  extractFormCategoriesFromResponse,
  isCustomFormCategory,
} from "components/DynamicForms/shared/formCategoryUtils";
import {
  isCustomSilFormCategoryTabId,
  mergeCustomSilCategoriesIntoFormsTab,
} from "../silHomeProfileCategoryTabs.utils";
import "./SilHomeProfileTabs.css";

const SilHomeProfileTabs = ({ ...props }) => {
  const spRosteringSetting = useSelector(getSpRosteringSetting);
  const {
    selectedAccommodationInfo,
    toggleState,
    setToggleState,
    setSelectedSilAccommodationLocally,
  } = props;

  const [customCategories, setCustomCategories] = useState([]);

  const [selectedTab] = useState(
    SilHomeselectedTabState.get()
      ? SilHomeselectedTabState.get()
      : SIL_HOME_PROFILE_TABS[0]
  );

  const toggleTab = (tab) => {
    const fromTab = toggleState?.name || toggleState?.id;
    const toTab = tab?.name || tab?.id;
    setToggleState(tab);
    SilHomeselectedTabState.save(tab);
    try {
      trackTabSwitch("sil_home", fromTab, toTab);
    } catch (e) {}
  };

  useEffect(() => {
    if (toggleState.id !== selectedTab.id) setToggleState(selectedTab);
  }, [selectedTab]);

  useEffect(() => {
    let cancelled = false;
    const loadCustomCategories = () => {
      silApi
        .silFormCategoriesApi()
        .then((response) => {
          if (cancelled) return;
          setCustomCategories(
            extractFormCategoriesFromResponse(response).filter(
              (category) =>
                isCustomFormCategory(category) ||
                String(category?.slug || "").toLowerCase().includes("-sil-")
            )
          );
        })
        .catch(() => {
          if (!cancelled) setCustomCategories([]);
        });
    };

    loadCustomCategories();
    window.addEventListener("sil-form-categories-changed", loadCustomCategories);
    return () => {
      cancelled = true;
      window.removeEventListener(
        "sil-form-categories-changed",
        loadCustomCategories
      );
    };
  }, [selectedAccommodationInfo?.uuid]);

  const loadTabComponent = () => {
    if (
      isCustomSilFormCategoryTabId(toggleState.id) &&
      toggleState.categoryUuid &&
      selectedAccommodationInfo?.uuid
    ) {
      return (
        <SubmittedFormView
          role='sil'
          parentSlug={toggleState.slug}
          participantId={selectedAccommodationInfo.id}
          supportPlansId={toggleState.categoryUuid}
          participantsUid={selectedAccommodationInfo.uuid}
          title={toggleState.name}
        />
      );
    }

    switch (toggleState.id) {
      case "property-profile":
        return (
          <>
            <PropertyProfile
              setSelectedSilAccommodationLocally={
                setSelectedSilAccommodationLocally
              }
              selectedAccommodationInfo={selectedAccommodationInfo}
              setToggleState={setToggleState}
            />
          </>
        );

      case "form-property-management":
        return (
          <SubmittedFormView
            parentSlug={PARENT_FORM_CATEGORY_SLUG.PropertyManagement.SLUG}
            participantId={selectedAccommodationInfo.id}
            supportPlansId={PARENT_FORM_CATEGORY_SLUG.PropertyManagement.UUID}
            participantsUid={selectedAccommodationInfo.uuid}
            title='Property Management'
            role='sil'
          />
        );

      case "form-participant-enrollment":
        return (
          <SubmittedFormView
            parentSlug={PARENT_FORM_CATEGORY_SLUG.PropertyEnrollment.SLUG}
            participantId={selectedAccommodationInfo.id}
            supportPlansId={PARENT_FORM_CATEGORY_SLUG.PropertyEnrollment.UUID}
            participantsUid={selectedAccommodationInfo.uuid}
            title='Property Enrollment'
            role='sil'
          />
        );
      case "form-others":
        return (
          <SubmittedFormView
            parentSlug={PARENT_FORM_CATEGORY_SLUG.SilFromsOthers.SLUG}
            participantId={selectedAccommodationInfo.id}
            supportPlansId={PARENT_FORM_CATEGORY_SLUG.SilFromsOthers.UUID}
            participantsUid={selectedAccommodationInfo.uuid}
            title='Others'
            role='sil'
          />
        );

      case "documents":
        return (
          // roleAccess(
          //   [],
          //   PERMISSION_KEYS.PARTICIPANT,
          //   PERMISSION_KEYS_CHILDREN.PARTICIPANT.DOCUMEMT.SHOW
          // ) && (
          <div>
            <Documents
              requiredDocuments={false}
              role={"sil"}
              worker={selectedAccommodationInfo}
            />
          </div>
          // )
        );

      case "sil-room":
        return (
          // roleAccess(
          // []
          // PERMISSION_KEYS.PARTICIPANT,
          // PERMISSION_KEYS_CHILDREN.PARTICIPANT.DOCUMEMT.SHOW
          // ) && <div>Sil Room</div>
          <SilRooms selectedAccommodationInfo={selectedAccommodationInfo} />
        );

      case "notes":
        return (
          <CaseNotesTab
            callFrom='silProfile'
            participantInfo={selectedAccommodationInfo}
            setToggleState={setToggleState}
            // isCaseNoteCall={isCaseNoteCall}
            // resetCaseNoteCall={resetCaseNoteCall}
          />
        );

      case "settings":
        return (
          // roleAccess(
          //   [],
          //   PERMISSION_KEYS.PARTICIPANT,
          //   PERMISSION_KEYS_CHILDREN.PARTICIPANT.SETTING.SHOW
          // )
          // &&
          <SilAccommodationSettings />
        );

      case "activity":
        return (
          <ActivityTab
            entityType="sil_home"
            entityId={selectedAccommodationInfo?.uuid}
          />
        );

      default:
        return <></>;
    }
  };

  const tabsToMap = useMemo(() => {
    const sourceTabs = mergeCustomSilCategoriesIntoFormsTab(
      SIL_HOME_PROFILE_TABS.map((tab) => ({
        ...tab,
        children: tab.children ? tab.children.map((child) => ({ ...child })) : [],
      })),
      customCategories
    );
    const filterTabs = (tab) => {
      if (tab.id === "activity" && !canViewAuditLogActivity(spRosteringSetting)) {
        return false;
      }
      const permissions = tab.permissions;
      return (
        !permissions ||
        roleAccess([], PERMISSION_KEYS.PARTICIPANT, permissions.SHOW)
      );
    };
    const filterChildTabs = (childTab) => {
      const permissions = childTab.permissions;
      return (
        !permissions || roleAccess([], PERMISSION_KEYS.PARTICIPANT, permissions)
      );
    };
    const filteredTabs = sourceTabs.filter(filterTabs).map((tab) => ({
      ...tab,
      children: tab.children?.length ? tab.children.filter(filterChildTabs) : tab.children,
    }));
    const fundingIndex = filteredTabs.findIndex(
      (x) =>
        x.id === 17 &&
        !parseBooleanVal(
          selectedAccommodationInfo?.support_coordination || false
        )
    );
    const finalTabs =
      fundingIndex !== -1
        ? filteredTabs.filter(
            (x) => x.id !== 17 && roleAccess([...x.roleAccess])
          )
        : filteredTabs.filter((x) => roleAccess([...x.roleAccess]));

    return finalTabs;
  }, [customCategories, selectedAccommodationInfo, spRosteringSetting]);

  return (
    <div className='bg-white shadow-lg rounded-lg'>
      <div className='print:hidden sticky z-[20] top-[79px]'>
        <div className='bloc-tabs bg-gradient py-4 rounded-t-lg text-white '>
          {tabsToMap.map((tab, index) => (
            <SilHomeProfileTabItem
              tabItem={tab}
              key={index}
              toggleTab={toggleTab}
              selectedTab={toggleState.id}
            />
          ))}
        </div>
      </div>
      <div className='content-tabs mb-8'>
        <div
          className={classNames(
            "content active-content",
            toggleState.id === "property-profile" && "!px-0 !py-0"
          )}
        >
          {loadTabComponent()}
        </div>
      </div>
    </div>
  );
};

export default SilHomeProfileTabs;
